var _path, _path2, _rect, _circle, _rect2, _rect3, _rect4, _circle2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _circle3, _rect11, _rect12, _rect13, _path5, _path6, _polygon, _path7, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelCostUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 685.62558,
    height: 570,
    viewBox: "0 0 685.62558 570",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.66548,631H301.142V165H710.66548Z",
    transform: "translate(-257.18721 -165)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M710.66548,631H301.142V165H710.66548ZM307.142,625.43451H704.66548v-454.869H307.142Z",
    transform: "translate(-257.18721 -165)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.64526,
    width: 409,
    height: 59.61236,
    fill: "#5b6d49"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103.28426,
    cy: 113.18049,
    r: 34.82182,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.10008,
    y: 88.60038,
    width: 119.28106,
    height: 10.24171,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.10008,
    y: 113.18049,
    width: 262.87059,
    height: 10.24171,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.10008,
    y: 137.7606,
    width: 262.87059,
    height: 10.24171,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.28426,
    cy: 398.20952,
    r: 34.82182,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.10008,
    y: 373.62944,
    width: 119.28106,
    height: 10.24171,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 166.10008,
    y: 398.20952,
    width: 262.87059,
    height: 10.24171,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 166.10008,
    y: 422.78963,
    width: 262.87059,
    height: 10.24171,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 57.19657,
    y: 15.2316,
    width: 51.89134,
    height: 7.51059,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.19657,
    y: 28.20444,
    width: 51.89134,
    height: 7.51059,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57.19657,
    y: 41.17728,
    width: 51.89134,
    height: 7.51059,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M754.62032,486.95794H257.18721V354.43206H754.62032Z",
    transform: "translate(-257.18721 -165)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M754.62032,486.95794H257.18721V354.43206H754.62032Zm-491.43311-6H748.62032V360.43206H263.18721Z",
    transform: "translate(-257.18721 -165)",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.72897,
    cy: 255.50361,
    r: 34.42732,
    fill: "#5b6d49"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 133.95883,
    y: 226.47667,
    width: 142.43459,
    height: 10.12568,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 133.95883,
    y: 250.77831,
    width: 313.8961,
    height: 10.12568,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 133.95883,
    y: 275.07994,
    width: 313.8961,
    height: 10.12568,
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M834.19714,521.8914a8.976,8.976,0,0,1,1.34976-.41861l15.18817-39.46156-6.44468-7.999,10.80073-11.304c3.11978,4.59224,18.55636,14.26767,13.85881,21.16666l-23.572,41.93506a8.95935,8.95935,0,0,1-5.39334,12.9961C829.46251,541.96047,823.95856,525.77043,834.19714,521.8914Z",
    transform: "translate(-257.18721 -165)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M848.57053,481.84191c-2.72426.78553-13.01455-15.21486-14.734-16.60666a10.65568,10.65568,0,0,1,14.60206-15.52258l15.827,11.07831a3.86054,3.86054,0,0,1,.58648,5.78008C862.95943,467.85809,851.26067,482.82418,848.57053,481.84191Z",
    transform: "translate(-257.18721 -165)",
    fill: "#5b6d49"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "596.767 556.889 584.507 556.888 582.675 509.6 596.769 509.601 596.767 556.889",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M857.08077,733.77261,817.55,733.77114c-.37031-20.92381,26.37055-15.21934,39.53149-15.88525Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "636.696 552.853 624.518 554.265 613.274 507.965 631.248 505.88 636.696 552.853",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M898.35922,729.29725l-39.26746,4.555c-2.77965-20.74152,24.44061-18.15752,37.43705-20.33588Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M856.14766,710.6626H835.989v-75.98l-11.77124-63.42871-16.10425-56.35743,37.77832-18.37841,7.20337,11.31933c1.11426,1.01563,19.16382,17.71729,21.11084,34.2666,1.98437,16.86817-17.18384,161.95606-18.001,168.124Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M809.47945,526.70068l-6.22364-27.2788c-1.45947-1.40381-15.273-15.56348.01709-33.65918l8.05664-21.00586,23.60328-7.31153,9.22876,7.14453a28.66462,28.66462,0,0,1,11.07006,24.565l-2.52026,38.59375Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M829.68885,392.19791c24.32308,13.84081,4.355,50.35976-20.42146,37.35567C784.94508,415.71323,804.91312,379.19428,829.68885,392.19791Z",
    transform: "translate(-257.18721 -165)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M762.77878,441.40417a9.7527,9.7527,0,0,1,.11176,1.53186L800.941,468.7067l10.05155-4.85908,9.3159,14.2111c-5.62813,2.17541-19.66262,16.143-25.81342,9.47538l-38.61054-35.25448a9.73752,9.73752,0,0,1-12.43526-8.90154C742.69324,431.46322,761.186,429.61152,762.77878,441.40417Z",
    transform: "translate(-257.18721 -165)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M801.65178,466.45657c-.16272-3.07721,19.30462-10.043,21.20042-11.52177a11.5812,11.5812,0,0,1,12.84891,19.27169L820.08546,488.243a4.19586,4.19586,0,0,1-6.2637-.79842C812.92385,485.12472,799.95121,469.06356,801.65178,466.45657Z",
    transform: "translate(-257.18721 -165)",
    fill: "#5b6d49"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M872.28389,695.59912l-25.01562-62.66357,16.666-23.95752,36.63623,84.46728Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M941.81279,735h-165a1,1,0,0,1,0-2h165a1,1,0,0,1,0,2Z",
    transform: "translate(-257.18721 -165)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M894.91158,410.38074c-8.12549,1.49878-16.62745-.97943-23.59034-5.42816-6.9624-4.44873-12.55713-10.73749-17.52148-17.34235-2.79492-3.718-5.49756-7.64-9.30176-10.316s-9.06738-3.86279-13.13135-1.60016c-3.58252,1.99469-5.16162,7.23047-3.05908,10.50763-5.644-1.41455-11.62939-.989-17.33349.21765-5.49512,1.16254-11.07862,3.1687-14.88184,7.30219-3.80273,4.13354-5.24121,10.84979-2.02783,15.4563L798.83247,410c8.70557-1.9856,12.728-1.10388,21.43311.8819-.29443-1.53974,2.12305-2.35913,3.3457-1.37787s.78272,2.933,1.57227,4.28717c3.36377,5.76843,3.36816,12.84674,1.64892,18.2088,8.625-3.58179,14.94629-13.2785,16.71289-22.44891a20.94649,20.94649,0,0,0-.92578-12.00177,17.04174,17.04174,0,0,0-2.88769-4.59058,22.84721,22.84721,0,0,1,8.73584,4.838c4.44092,3.86255,7.65185,8.90448,11.20215,13.59857,3.55029,4.69416,7.69482,9.24262,13.14941,11.45313,8.36426,3.3894,18.29834.4248,25.16455-5.43195,5.35791-4.57007,9.145-10.628,12.16113-17.04284A23.34707,23.34707,0,0,1,894.91158,410.38074Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M910.145,400.3736a18.42549,18.42549,0,0,0,2.38428-5.47632C911.7856,396.73492,910.9941,398.56763,910.145,400.3736Z",
    transform: "translate(-257.18721 -165)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelCostUpdate);
export default __webpack_public_path__ + "static/media/fuelCostUpdate.786d878b2a1e777b3c238c6b92f3ac77.svg";
export { ForwardRef as ReactComponent };